module.exports = new __parcel__URL__("search-no-results.1d478205.svg").toString();